function chmItemsSelector($selector) {
    var _this, STATUS;

    STATUS = {
        value: null,
        onChange: null
    };

    function update() {
        $selector.attr('data-value', STATUS.value);
        $selector.find('[data-choice]').attr('data-selected', 'no').filter(`[data-choice="${STATUS.value}"]`).attr('data-selected', 'yes');
    }

    function triggerChange() {
        if (STATUS.onChange) {
            try {
                STATUS.onChange.call(_this, STATUS.value);
            } catch(e) {
                console.error(e);
            }
        }
    }

    $selector.find('[data-change-value]').on('click', function() {
        var $current, $next, currentIndex, nextIndex, step;

        step = (this.dataset.changeValue === 'next') ? 1 : -1;

        $current = $selector.find('[data-choice][data-selected="yes"]');
        if ($current.length === 0) {
            _this.set($selector.find('[data-choice]').first().attr('data-choice'));
            return;
        }

        currentIndex = $current.index();
        nextIndex = currentIndex + step;

        if (nextIndex < 0) {
            nextIndex = $selector.find('[data-choice]').length - 1;
        }
        if (nextIndex >= $selector.find('[data-choice]').length) {
            nextIndex = 0;
        }

        $next = $selector.find('[data-choice]').eq(nextIndex);

        $selector.find('[data-choice]').toggleClass('movePrev', (step < 0));

        STATUS.value = $next.attr('data-choice');
        update();
        triggerChange();
    });

    _this = {
        set: function(value) {
            STATUS.value = value;
            update();
            return _this;
        },
        get: function() {
            return STATUS.value;
        },
        onChange: function(callback) {
            STATUS.onChange = callback;
            return _this;
        }
    }

    return _this;
}